<template>
  <div class="app-part-case-view">
    <ul class="flex-middle-x layout-flex-justify-content_space-between">
      <li class="banner-show" v-for="(item,index) in partList">
        <img class="bannerImg" :src="item.imgUrl" alt="" />
        <p>{{item.content}}</p>
      </li>
    </ul>
    <div @click="actionClickPart" v-if="isPart">
      查看全部>
    </div>
    <div @click="actionClickPartNone" v-else>
      收起>
    </div>
  </div>
</template>
<script>
  export default {
    name:'',
    data(){
      return {
        partList:[],
        partLength:4,
        isPart:true
      }
    },
    props:{
      bannerList: Array
    },
    methods:{
      actionClickPart(){
        this.partList = this.bannerList.slice(0, this.partLength);
        this.isPart = false;
      },
      actionClickPartNone(){
        this.partList = this.bannerList.slice(0, 4);
        this.isPart = true;
      }
    },
    mounted(){
      this.partList = this.bannerList.slice(0, 4);
      this.partLength = this.bannerList.length;
    }
  }
</script>
<style lang="scss" rel="stylesheet/scss" scoped="">
  .app-part-case-view{
    ul{
      width:100%;
      padding:0.3rem;
      flex-wrap: wrap;
      .banner-show{
        width:3.1rem;
        height:3.5rem;
        cursor: pointer;
        position: relative;
        z-index:2;
        .bannerImg {
          width:100%;
        }
        p{
          color:$color-1;
          font-size:0.22rem;
          padding:0.1rem 0;
          border-left:1px solid #dddddd;
          border-right:1px solid #dddddd;
          border-bottom:1px solid #dddddd;
          border-left:1px solid #dddddd;
          position: relative;
          top:-3px;
        }
      }
    }
    div{
      width:2.53rem;
      height:0.5rem;
      border:1px solid #fac138;
      font-size:0.3rem;
      color:#ffbd1f;
      margin:auto;
    }
  }
</style>
